import { parseSync } from 'svgson'
import { type IconNode } from 'lucide-vue-next'

// import the custom icons from the local directory
import rawInstanceId from './instance-id.svg?raw'

// utility, converts the raw icon to a Lucide-like icon
const convertIcon = (rawIcon: string | { template: string }): IconNode => {
  const svg = typeof rawIcon === 'string' ? rawIcon : rawIcon.template
  const parsed = parseSync(svg)
  return parsed.children.map((i) => [i.name, i.attributes]) as IconNode
}

// export the custom icons
export const instanceId = convertIcon(rawInstanceId)
